window.Sparkle ??= {};
window.Sparkle.Spotlight ??= {};

Sparkle.Spotlight.ItemsList = class ItemsList {
  constructor(itemsData, options) {
    this.render = this.render.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleMousemove = this.handleMousemove.bind(this);
    this.isEmpty = this.isEmpty.bind(this);
    this.setItems = this.setItems.bind(this);
    this.setHighlight = this.setHighlight.bind(this);
    this.clearHighlight = this.clearHighlight.bind(this);
    this.scrollTo = this.scrollTo.bind(this);
    this.resetScroll = this.resetScroll.bind(this);
    this._getItemFromElement = this._getItemFromElement.bind(this);
    this._buildItems = this._buildItems.bind(this);
    this._triggerEvent = this._triggerEvent.bind(this);
    if (itemsData == null) {
      itemsData = [];
    }
    if (options == null) {
      options = {};
    }
    this.options = jQuery.extend(
      { itemClass: Sparkle.Spotlight.ItemsList.Item }, // Override the class used for the items in the list
      options,
    );

    this.el = jQuery(`<${this.tag}>`, {
      class: "spotlight-items-list",
      id: this.options.spotlightId,
      "aria-activedescendant": "",
      role: "listbox",
    });
    this.items = this._buildItems(itemsData);

    // BEHAVIOUR

    jQuery(this.el).on("click", this.handleClick);
    jQuery(this.el).on("mousemove", "[data-list-item]", this.handleMousemove);
  }

  render() {
    this.el.empty();

    jQuery.each(this.items, (_, item) => this.el.append(item.render().el));

    return this;
  }

  // EVENT HANDLERS

  handleClick(event) {
    const item = this._getItemFromElement(event.target);
    if (item) {
      return this._triggerEvent("clickitem", item);
    }
  }

  // Scrolling the list with the keyboard slides a row under a resting pointer, and the browser
  // then fires `mouseover` on it without any `mousemove`. Reacting to movement instead means only
  // a pointer the user actually moved takes the selection.
  handleMousemove(event) {
    if (this._pointerPosition?.[0] === event.clientX && this._pointerPosition?.[1] === event.clientY) {
      return;
    }
    this._pointerPosition = [event.clientX, event.clientY];

    const item = this._getItemFromElement(event.target);
    if (item) {
      return this._triggerEvent("pointeroveritem", item, item.index);
    }
  }

  // HELPER FUNCTIONS

  isEmpty() {
    return this.items.length === 0;
  }

  setItems(itemsData, identifier) {
    this.items = this._buildItems(itemsData, identifier);
    return this.render();
  }

  setHighlight(index) {
    this.clearHighlight();

    const item = this.items[index];
    if (item) {
      item.setHighlight(true);
      this.el.attr("aria-activedescendant", item.el.attr("id"));

      return this._triggerEvent("activedescendantChanged", item.el.attr("id"));
    }
  }

  clearHighlight() {
    this.el.attr("aria-activedescendant", "");
    jQuery.each(this.items, function () {
      return this.setHighlight(false);
    });

    return this._triggerEvent("activedescendantChanged", "");
  }

  scrollTo(index) {
    const item = this.items[index];
    if (!item) {
      return;
    }

    return item.el[0].scrollIntoView({ block: "nearest" });
  }

  // Whichever of the two scrolls goes back to the top: admin gives the container the overflow, the
  // omnisearch gives it to the list. Setting it on the other is a no-op. `scrollIntoView` would
  // scroll every scrollable ancestor instead, and where neither has an overflow that is the page.
  resetScroll() {
    for (const element of [this.el[0], this.el[0].parentElement]) {
      if (element) {
        element.scrollTop = 0;
      }
    }
  }

  // PRIVATE

  _getItemFromElement(element) {
    const itemElement = jQuery(element).closest("[data-list-item]");
    return itemElement.data("list-item");
  }

  _buildItems(items, identifier) {
    return jQuery.map(items, (data, index) => {
      const item = new this.options.itemClass(data, identifier);
      item.index = index;
      item.el.attr("id", this.options.spotlightId + "-" + index);
      item.el.data({ "list-item": item }).attr({ "data-list-item": "" });
      return item;
    });
  }

  _triggerEvent(name, ...payload) {
    return jQuery(this).triggerHandler(name, payload);
  }
};
Sparkle.Spotlight.ItemsList.prototype.tag = "div";
